export default __webpack_public_path__ + "static/media/rocket-Artboard.d3a40f51.png";